import { gql } from '@apollo/client';

export default gql`
  query getItems($isRTL: Boolean) {
    getItems(isRTL: $isRTL) {
      ok
      error
      data {
        _id
        branch
        autoNo
        docNo
        itemType
        barcode

        disabled
        additionId

        name
        nameAr
        desc
        qty
        cost
        price
        photo

        categoryId
        categoryName
        categoryNameAr

        brandId
        brandName
        brandNameAr

        departmentId
        departmentName
        departmentNameAr
        departmentColor

        employeeId
        employeeName
        employeeNameAr
        employeeColor
        employeePhone

        resourseId
        resourseName
        resourseNameAr

        userId
        note

        createdAt
        updatedAt
      }
    }
  }
`;
